import {Messages, Product} from '../../@types/wishlist.js';
import {FilterOptionState} from './filter-option-state.js';
import {OptionUIModel} from './option-ui-model.js';
import {createLabel} from './filter-label.js';
import {FilterAction} from './filter-action.js';
import {SortAction} from './sort-action.js';

export class FilterOption implements OptionUIModel {
  readonly id: string;

  readonly groupId?: string;

  private state: FilterOptionState;

  private editState?: FilterOptionState;

  readonly action: SortAction | FilterAction;

  readonly isDefault: boolean;

  readonly isOneClick: boolean;

  readonly predefinedLabel?: string;

  private readonly shortLabelMsgKey?: string;

  public constructor(
    id: string,
    action: SortAction | FilterAction,
    predefinedLabel?: string,
    groupId?: string,
    isDefault: boolean = false,
    isOneClick: boolean = false,
    shortLabelMsgKey?: string,
  ) {
    this.id = id;
    this.action = action;
    this.state = new FilterOptionState(isDefault);
    this.editState = undefined;
    this.isDefault = isDefault;
    this.isOneClick = isOneClick;
    this.predefinedLabel = predefinedLabel;
    this.groupId = groupId;
    this.shortLabelMsgKey = shortLabelMsgKey;
  }

  public equalsId(otherId: string) {
    return this.id === otherId;
  }

  public label(messages: Messages): string {
    return this.predefinedLabel ?? createLabel(messages, 'ents_wishlist_filter_option_', this.id);
  }

  public shortLabel(messages: Messages): string {
    return this.shortLabelMsgKey ?
      messages[this.shortLabelMsgKey] ?? this.label(messages) : this.label(messages);
  }

  public isEdited(): boolean {
    return this.editState !== undefined;
  }

  public applyEditState(): void {
    if (this.editState) {
      this.state = this.editState.copy();
      this.undoEditState();
    }
  }

  public undoEditState(): void {
    this.editState = undefined;
  }

  public isActive(includeEditState: boolean = true) {
    if (includeEditState && this.editState) {
      return this.editState.isActive();
    }
    return this.state.isActive();
  }

  public toggleActivationState() {
    this.editState ??= this.state.copy();
    this.editState.toggleActivationState();
    if (this.state.isActive() === this.editState?.isActive()) {
      this.undoEditState();
    }
  }

  public getCount(): number {
    return this.editState ? this.editState.getCount() : this.state.getCount();
  }

  public resetCount() {
    if (this.editState) {
      return this.editState.resetCount();
    }
    return this.state.resetCount();
  }

  public countProduct(product: Product) {
    if (this.action instanceof FilterAction && !this.action.filterStrategy(product)) {
      return;
    }

    this.state.incCount();
    if (this.editState) {
      this.editState.incCount();
    }
  }

  public reset() {
    if (this.isActive(true)) {
      this.toggleActivationState();
    }
  }
}
